module.exports = __webpack_public_path__ + "img/clip_image088.5277b527.png";